import { createFileRoute, useParams } from "@tanstack/react-router";
import { MWorkOrderDetailsHeader } from "@/components/domain/WorkOrder/Mobile/WorkOrderDetails/WorkOrderDetailsHeader/WorkOrderDetailsHeader";
import { WorkOrderStatusCard } from "@/components/domain/WorkOrder/Mobile/Components/WorkOrderStatusCard/WorkOrderStatusCard";
import {
  WorkOrderDetailsContainer,
  WorkOrderDetailsContent,
} from "@/components/domain/WorkOrder/Mobile/WorkOrderDetails/WorkOrderDetails";

import { WorkOrderDetailsFooter } from "@/components/domain/WorkOrder/Mobile/WorkOrderDetails/WorkOrderDetailsFooter/WorkOrderDetailsFooter";
import { WorkOrderScopeCard } from "@/components/domain/WorkOrder/Mobile/Components/WorkOrderScopeCard/WorkOrderScopeCard";
import { WorkOrderLocationCard } from "@/components/domain/WorkOrder/Mobile/Components/WorkOrderLocationCard/WorkOrderLocationCard";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";
import { MobileNavbarTemp } from "@/components/domain/WorkOrder/Mobile/MobileNavbar/MobileNavbar.tsx";
import { WorkOrderDetailsScheduleCard } from "@/components/domain/WorkOrder/Mobile/WorkOrderDetails/WorkOrderDetailsScheduleCard/WorkOrderDetailsSchedule.card.tsx";

export const Route = createFileRoute("/_authenticated/mobile/work-order/details/$id/")({
  component: WorkOrderMobileDetailsPage,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function WorkOrderMobileDetailsPage() {
  const { id } = useParams({ from: "/_authenticated/mobile/work-order/details/$id/" });

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <MobileNavbarTemp>Work Order Details</MobileNavbarTemp>
      <WorkOrderDetailsContainer woId={id}>
        <MWorkOrderDetailsHeader />
        <WorkOrderDetailsContent>
          <WorkOrderStatusCard />
          <WorkOrderScopeCard />
          <WorkOrderLocationCard />
          <WorkOrderDetailsScheduleCard />
        </WorkOrderDetailsContent>
        <WorkOrderDetailsFooter />
      </WorkOrderDetailsContainer>
    </div>
  );
}
